
// Marital Status Options
export const maritalStatusOptions = [
  "Single",
  "Married", 
  "Divorced",
  "Widowed",
  "Other"
] as const;

// Employment Status Options
export const employmentStatusOptions = [
  "Employed",
  "Self-employed",
  "Unemployed",
  "Retired",
  "Student",
  "Other"
] as const;

// Gender Options
export const genderOptions = [
  "Male",
  "Female",
  "Other",
  "Prefer not to say"
] as const;

// Lead Status Options - imported from shared constants
export {
  LeadStatus,
  type LeadStatusValue,
  getAllLeadStatusValues,
  getLeadStatusDisplayName,
  isValidLeadStatus,
  normalizeLeadStatus,
  LEAD_STATUS_DISPLAY_NAMES,
  LEGACY_LEAD_STATUS_MAP
} from '@/app/_module/constants/leadStatus';

// Type exports
export type MaritalStatus = typeof maritalStatusOptions[number];
export type EmploymentStatus = typeof employmentStatusOptions[number];
export type Gender = typeof genderOptions[number];